import { Injectable } from '@angular/core';
import { ApiService } from '../../providers/apiService/api.service';
import { StorageService } from '../../providers/storageService/storage.service';
import { AlertController, NavController } from '@ionic/angular';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  lockTimer:number;
  theTimer:any;
  countdowntimer:any;

  constructor(
    private apiService: ApiService,
    public storageService: StorageService,
    public navCtrl: NavController,
    public alertController: AlertController,
  ) 
  { 
  }

  resetLogoutTimer() {
    clearInterval(this.theTimer);
    this.storageService.getObject('userInfo').then((result) => {
      if (result != null) {
        const params = {
          User: result,
        };
        this.apiService.login('getUserSettings',params).subscribe (
          (res) => {
            if (res.error === false) {

              var timeoutValue = res.lockTimeout;
              this.storageService.setObject('userLockTimeout', timeoutValue);
              this.lockTimer = timeoutValue;
              this.storageService.setObject('lockTimer', timeoutValue);
              //console.log('reset to '+timeoutValue);
              this.storageService.setObject('timerStarted', null);
            }
          }
        );
      }
    });
  }

  startTimer() {
    //console.log('start');
    
        this.storageService.getObject('userInfo').then((result) => 
        {
          if (result != null) 
          {
            this.storageService.getObject('lockTimer').then((timerResult) => 
            {   
              //console.log('timer result: '+timerResult);  
              this.theTimer = setInterval(() => {            
                //this.storageService.set("lockTimer",this.lockTimer);
                //console.log('lock timer: '+this.lockTimer);
                if (this.lockTimer <= 0)
                {
                  //console.log('locking after timeout');

                  ////////alert before timeout to confirm - if not confirmed after 10 seconds, go to lock??
                  clearInterval(this.theTimer);
                  this.presentAlertConfirm();
                  
                  //clearInterval(this.theTimer);
                  //this.navCtrl.navigateRoot('/lock');    
                }
                else
                {
                  this.lockTimer = this.lockTimer-1000;
                  this.storageService.set("lockTimer",this.lockTimer);
                }
              }, 1000);
            });
          }
        });
      }

      async presentAlertConfirm() {
        const alert = await this.alertController.create({
          cssClass: 'missingAlert',
          header: 'App Timeout',
          message: 'Your App Timeout has been reached.  Do you want to continue or lock the app?  The app will automatically lock if you do not respond within 10 seconds.',
          buttons: [
            {
              text: 'Continue',
              role: 'continue',
              cssClass: 'secondary',
              handler: (blah) => {
                //console.log('Confirm OK: blah');
                clearInterval(this.countdowntimer);
              },
            },
            {
              text: 'Lock',
              role: 'lock',
              cssClass: 'secondary',
              handler: (blah) => {
                //console.log('Confirm lock: blah');
                clearInterval(this.countdowntimer);
                clearInterval(this.theTimer);
                this.navCtrl.navigateRoot('/lock'); 
              },

            }
           
          ],
        });
    
        await alert.present().then(x=>
          {
            var countdown = 10;
            this.countdowntimer = setInterval(() => {  
              countdown--;
              //console.log(countdown);
              if (countdown == 0)
              {
                clearInterval(this.countdowntimer);
                clearInterval(this.theTimer);
                alert.dismiss();
                this.navCtrl.navigateRoot('/lock'); 

              }
            }, 1000);
          }
        );
      }
    }
